module.exports = __webpack_public_path__ + "static/img/aRZ_pic04.4a45430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic04.jpg
// module id = vrkc
// module chunks = 5